require('./index-block-subscribe-form.less');

import SubscribeIndex from './index-subscribe.js';

jQuery(function() {
    const subscribeIndex = new SubscribeIndex();
    subscribeIndex.init();
});



// WEBPACK FOOTER //
// ./blocks/index-block-subscribe-form/index-block-subscribe-form.js